import Price from '../shop/Price';
import { TAX_RATE } from '../../../utils/tax';

type Props = {
  order: IOrder,
  ignoreShipping?: boolean,
}


const InvoiceReviewTaxes = ({ order, ignoreShipping }: Props) => {
  // Prefer the tax the server actually recorded on the order; only fall
  // back to recomputing from line items when the order carries no server
  // total (e.g. a pre-submit cart-shaped order).
  if (order.tax?.value !== undefined) {
    return <Price price={order.tax.value} showZero />;
  }
  const items = order.items;
  const subtotal = items.filter(item => !item.item.name.startsWith("Shipping")).reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);
  const shipping = items.filter(item => item.item.name.startsWith("Shipping")).reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);
  const discountedSubtotal = order.discountAmount ? subtotal - order.discountAmount : subtotal;

  const taxes = Math.round((discountedSubtotal + shipping) * TAX_RATE);

  return (
    <Price price={taxes}/>
  )
}

export default InvoiceReviewTaxes